module.exports = __webpack_public_path__ + "static/media/small-udemy.6ac97f64.png";